export default class ThemeDto {
    constructor(obj = {}) {
        this.id = obj.id
        this.name = obj.name
        this.color = obj.color && !obj.color.includes('rgb') ? `rgb(${obj.color})` : obj.color
        this.isAquaDBTheme = obj.isAquaDBTheme
        this.themeOrder = obj.themeOrder
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin
    }
}
